export class PricingCopilotMatrixUtilityChartData {
	public date: string;
	public value: number;

	constructor(chartData?: PricingCopilotMatrixUtilityChartData) {
		Object.assign(this, chartData);
	}
}
